import { CUSTOM_ELEMENTS_SCHEMA, NgModule, NO_ERRORS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpHeaders, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
// import { HttpModule } from '@angular/http';

import { LoginComponent } from '../../components/login/login.component';
import { LoginService } from './login.service';
import { LoginRoutingModule } from './login-routing.module';
import { LoaderService } from './../../loader/loader.service';
import { SharedModule } from '../../shared/shared.module';
import { AssistBotService } from '../ai-assist/assist-bot.service';
import { FooterComponent } from "../../footer/footer.component";
import { InputTextModule } from 'primeng/inputtext';
import { ButtonModule } from 'primeng/button';
import { PasswordModule } from 'primeng/password';

@NgModule({ declarations: [
        LoginComponent
    ],
    schemas: [
        CUSTOM_ELEMENTS_SCHEMA,
        NO_ERRORS_SCHEMA
    ], imports: [CommonModule,
        FormsModule,
        ReactiveFormsModule,
        LoginRoutingModule,
        InputTextModule,
        SharedModule,
        ButtonModule,
        PasswordModule
        // HttpModule
        ,
        FooterComponent], providers: [LoginService, LoaderService, AssistBotService, provideHttpClient(withInterceptorsFromDi())] })
export class LoginModule { }
